import React, { useState } from 'react'
import { Select } from 'grommet'
import { I18n } from 'galarm-config'
import { AlarmUtils } from 'galarm-shared'

const DEVICE_TIMEZONE_VALUE = '__device__'

const SelectTimezone = ({ selectedTimezone, onSaveTimezone }) => {
  const [searchText, setSearchText] = useState('')

  const timezones = AlarmUtils.getAllTimezones()
  const filteredTimezones = timezones.filter(timezone =>
    timezone.label.toLowerCase().includes(searchText.toLowerCase())
  )
  const timezoneOptions = filteredTimezones.map(timezone => {
    if (selectedTimezone === timezone.value) {
      return { ...timezone, selected: true }
    } else {
      return { ...timezone, selected: false }
    }
  })

  // Prepend "Use device timezone" option when a timezone is selected and not filtering
  if (selectedTimezone && !searchText) {
    timezoneOptions.unshift({
      label: I18n.t('useDeviceTimezone'),
      value: DEVICE_TIMEZONE_VALUE,
      selected: false
    })
  }

  const onSearch = text => {
    setSearchText(text)
  }

  const onSelectTimezone = item => {
    if (item.value === DEVICE_TIMEZONE_VALUE) {
      onSaveTimezone(item, false)
    } else {
      onSaveTimezone(item, !item.selected)
    }
  }

  return (
    <Select
      placeholder={I18n.t('deviceTimezone')}
      searchPlaceholder={I18n.t('searchForATimezone')}
      value={selectedTimezone || ''}
      valueKey={{ key: 'value', reduce: true }}
      labelKey="label"
      options={timezoneOptions}
      onChange={({ option }) => {
        onSelectTimezone(option)
      }}
      onClose={() => setSearchText('')}
      onSearch={text => onSearch(text)}
    />
  )
}

export default SelectTimezone
